<template>
  <SecondaryBackground>
    <div class="mt-5 sm:mt-16 px-4 lg:flex lg:items-center lg:justify-center">
      <DefaultCard class="lg:mr-24 mb-8 lg:mb-0 z-20">
        <form class="min-w-full lg:min-w-30 max-w-2xl lg:px-12 py-4" @submit.prevent="submit">
          <Heading class="mb-16" center>Get In Touch</Heading>

          <div class="text-left mb-4 mt-4">
            <label for="fullName" class="text-sm">Full Name<small>*</small></label>
            <input type="text" class="input mt-2" id="fullName" v-model="fullName" />
          </div>

          <div class="text-left mb-4 mt-4">
            <label for="email" class="text-sm">Email<small>*</small></label>
            <input type="email" class="input mt-2" id="email" v-model="email" />
          </div>

          <div class="text-left mb-8 mt-4">
            <label for="msg" class="text-sm">Message<small>*</small></label>
            <textarea class="textarea mt-2 resize-none" id="msg" v-model="message" />
          </div>

          <LoadingButton
            type="submit"
            class="btn btn-primary w-full rounded-lg font-semibold"
            :loading="loading"
            :disabled="!canSubmit"
          >
            Send
          </LoadingButton>
        </form>
      </DefaultCard>
      <div class="mb-16 sm:mb-0">
        <h2 class="text-primary text-base mb-2 font-semibold">Email</h2>
        <span class="block mb-10">support@buildabox.co</span>

        <h2 class="text-primary text-base mb-2 font-semibold">Mailing Address</h2>
        <span class="block">5424 Sunol Blvd,</span>
        <span class="block">Suite 10-226 Pleasanton</span>
        <span class="block">Ca 94566</span>
      </div>
    </div>
  </SecondaryBackground>
</template>

<script>
  import {required, minLength, email} from 'vuelidate/lib/validators'
  import axios from 'axios'
  import LoadingButton from "@/components/common/LoadingButton"
  import SecondaryBackground from "@/components/common/layout/SecondaryBackground"
  import Heading from "@/components/common/Heading"
  import DefaultCard from "@/components/common/layout/DefaultCard"

  export default {
    name: "GetInTouch",
    data() {
      return {
        fullName: '',
        email: '',
        message: '',
        loading: false,
      }
    },
    computed: {
      canSubmit() {
        return !this.$v.$invalid;
      }
    },
    validations: {
      fullName: {
        required,
        minLength: minLength(2),
      },
      email: {
        required,
        email,
      },
      message: {
        required,
        minLength: minLength(2)
      }
    },
    methods: {
      async submit() {
        try {
          this.loading = true;
          await axios.post(`${process.env.VUE_APP_API_URL}/api/feedback`, {
            full_name: this.fullName,
            email: this.email,
            message: this.message
          })

          this.$analytics.fbq.event('CompleteRegistration')
          
          this.fullName = ''
          this.email = ''
          this.message = ''
          this.loading = false
        } catch (e) {
          this.loading = false
        }
      }
    },
    components: {LoadingButton, SecondaryBackground, Heading, DefaultCard}
  }
</script>

<style scoped>

</style>
